import auth from './auth';
import main from './main'

let list = [];
const routes = list.concat(auth,main);
export default routes;